import { useParams } from 'react-router-dom'

export const useProjectIdParam = (): string => {
  const params: any = useParams()
  return params?._id ?? undefined
}
